// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class NoteTaskModelResponse {
    static getAttributeTypeMap() {
        return NoteTaskModelResponse.attributeTypeMap;
    }
}
NoteTaskModelResponse.discriminator = undefined;
NoteTaskModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "NoteTaskModel"
    }
];
//# sourceMappingURL=noteTaskModelResponse.js.map